import { Link, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { List, X, SteeringWheel } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/", label: "Home" },
    { to: "/#services", label: "Services" },
    { to: "/#process", label: "Process" },
    { to: "/#contact", label: "Contact" },
  ];

  return (
    <header className="fixed top-0 inset-x-0 z-[100] border-b border-border bg-black/60 backdrop-blur-2xl">
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <SteeringWheel size={26} weight="fill" className="text-primary transition-transform group-hover:rotate-90 duration-500" />
          <span className="font-display font-black tracking-tighter uppercase text-sm sm:text-base">
            Ranchi<span className="text-primary">·</span>Digital Seva
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-xs font-mono uppercase tracking-widest text-muted-foreground hover:text-primary transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Link
                to={user.role === "admin" ? "/admin" : "/dashboard"}
                data-testid="nav-dashboard"
                className="text-xs font-mono uppercase tracking-widest text-foreground hover:text-primary transition-colors"
              >
                {user.role === "admin" ? "Admin" : "Dashboard"}
              </Link>
              <button
                data-testid="nav-logout"
                onClick={() => { logout(); navigate("/"); }}
                className="px-4 py-2 text-xs font-mono uppercase tracking-widest border border-border hover:border-primary hover:text-primary transition-colors rounded-sm"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="text-xs font-mono uppercase tracking-widest text-foreground hover:text-primary transition-colors">
                Login
              </Link>
              <Link
                to="/apply"
                data-testid="nav-apply"
                className="px-5 py-2.5 text-xs font-mono uppercase tracking-widest bg-primary text-primary-foreground font-medium hover:bg-primary/90 transition-colors rounded-sm"
              >
                Apply Now
              </Link>
            </>
          )}
        </div>

        <button data-testid="nav-menu-toggle" className="md:hidden text-foreground" onClick={() => setOpen(!open)}>
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden border-t border-border bg-black"
          >
            <div className="px-5 py-6 flex flex-col gap-4">
              {links.map((l) => (
                <a key={l.label} href={l.to} onClick={() => setOpen(false)} className="font-mono uppercase text-sm tracking-widest text-muted-foreground">
                  {l.label}
                </a>
              ))}
              <div className="h-px bg-border my-2" />
              {user ? (
                <>
                  <Link to={user.role === "admin" ? "/admin" : "/dashboard"} onClick={() => setOpen(false)} className="font-mono uppercase text-sm tracking-widest">
                    {user.role === "admin" ? "Admin Panel" : "Dashboard"}
                  </Link>
                  <button onClick={() => { logout(); setOpen(false); navigate("/"); }} className="text-left font-mono uppercase text-sm tracking-widest text-accent">Logout</button>
                </>
              ) : (
                <>
                  <Link to="/login" onClick={() => setOpen(false)} className="font-mono uppercase text-sm tracking-widest">Login</Link>
                  <Link to="/apply" onClick={() => setOpen(false)} className="font-mono uppercase text-sm tracking-widest text-primary">Apply Now</Link>
                </>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
